var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "213px",
    height: "125px",
    viewBox: "0 0 213 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grey_eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.5,0 C142.782349,0 177.562923,19.0876056 210.841721,57.2628169 C213.398477,60.1957563 213.466913,64.5292122 211.042195,67.5374663 L210.860327,67.7551779 L209.868871,68.8943476 C177.13354,106.298116 142.67725,125 106.5,125 C69.9497389,125 35.283189,105.91047 2.5003501,67.7314113 C-0.019256693,64.7970645 -0.0716865672,60.4938856 2.33827204,57.5029508 L2.51900491,57.2864827 L3.5104213,56.1464843 C36.2431922,18.7154948 70.5730517,0 106.5,0 Z M106.708033,9.97285046 C77.157799,9.97285046 47.503031,25.3541202 17.7437288,56.1166596 L16.8418977,57.0535639 C13.9077857,60.1170091 13.8748516,64.938037 16.7668369,68.0412823 C45.1538636,98.5019853 75.1342622,113.732337 106.708033,113.732337 C137.978034,113.732337 167.519228,98.7936363 195.331614,68.9162352 L196.173885,68.0062872 C199.021396,64.9125709 198.988039,60.1425202 196.097541,57.0889294 C166.364465,25.6782101 136.567962,9.97285046 106.708033,9.97285046 Z M106.5,18 C131.076671,18 151,37.9233286 151,62.5 C151,87.0766714 131.076671,107 106.5,107 C81.9233286,107 62,87.0766714 62,62.5 C62,37.9233286 81.9233286,18 106.5,18 Z",
    id: "grey_eye",
    fill: "#D3D3D3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyEye);
export default __webpack_public_path__ + "static/media/grey_eye.5150a1f8a7f0b723f2e2c078d5afad5a.svg";
export { ForwardRef as ReactComponent };